
import {authentication} from '../../config/auth/AppConstants';
import {user} from '../../config/auth/AppConstants';

// The session lives in browser-session cookies: no Expires or Max-Age, so the
// browser deletes them when it closes. Unlike sessionStorage they are shared by
// every tab, so a new tab, an email link or a bookmark opens already signed in,
// one logout signs out every tab, and every tab holds the same account as the
// browser-wide Firebase sign-in. A refresh, and the trips out to Instagram or
// Facebook and back, keep them.
//
// localStorage, the old home, never emptied by itself: the token stayed there
// long after the backend had expired it (Knox TTL, 12h), and the next visit
// started with a dead token.
//
// SameSite=Lax, not Strict: nothing reads these on a server (the API takes the
// token from the Authorization header), so the attribute only has to keep them
// readable by the page in every browser, including on a page reached from
// another site: the redirect back from Instagram/Facebook, or an email link.
function cookieAttributes(){
    return '; path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
}

function readCookie(name){
    var prefix = name + '=';
    var match = document.cookie.split('; ').find(function(part){ return part.indexOf(prefix) === 0; });
    return match === undefined ? null : decodeURIComponent(match.slice(prefix.length));
}

function writeCookie(name, value){
    document.cookie = name + '=' + encodeURIComponent(value) + cookieAttributes();
}

function deleteCookie(name){
    document.cookie = name + '=; Max-Age=0' + cookieAttributes();
}

// A session saved by an older build is still sitting in localStorage. Cleared
// on every load so it can never be read back.
try {
    localStorage.removeItem(user.user);
    localStorage.removeItem("creator_userId");
} catch (err) {
    /* storage blocked (private mode) — nothing can have been saved there */
}

// Same lifetime as the session cookies, so missing on load means this is the
// first page of a new browser session: the browser was closed since the last
// visit. Firebase keeps its own sign-in in IndexedDB, which outlives the
// browser, so index.js signs that out too at this moment.
var BROWSER_SESSION_COOKIE = 'creator_browser_session';

// The last visit's copy of each page, painted while the app loads (written by
// PrivateRoute.js, painted by public/index.html): an index under this key and
// one entry per page under PAGE_PREVIEW_KEY + ':' + path. It belongs to the
// session that drew it: gone at logout, on an expired token and with the
// browser session.
export var PAGE_PREVIEW_KEY = 'gn_preview';

export function clearPagePreviews(){
    try {
        Object.keys(localStorage)
            .filter(function(key){ return key === PAGE_PREVIEW_KEY || key.indexOf(PAGE_PREVIEW_KEY + ':') === 0; })
            .forEach(function(key){ localStorage.removeItem(key); });
    } catch (err) {
        /* storage blocked — nothing can have been saved there */
    }
}

export function beginBrowserSession(){
    if (readCookie(BROWSER_SESSION_COOKIE) !== null) return false;
    writeCookie(BROWSER_SESSION_COOKIE, '1');
    clearPagePreviews();
    return true;
}

export function setUserId(id){
    writeCookie("creator_userId", id);
}

export function getUserId()
{
    return readCookie("creator_userId");
}
export function getSelfToken(){
    var obj;
    var key=user.selfToken;
    obj=(readCookie(user.user));
    if(obj!=null){
        obj=JSON.parse(obj);
        return obj[key];
    }else{
        return obj;
    }
}
export function setSelfToken(token){
    var obj=readCookie(user.user);
    if(obj){
        obj=JSON.parse(obj);
    }else{
        obj={};
    }
    // var obj={};
    var key=user.selfToken;
    obj[key]=token;
    writeCookie(user.user, JSON.stringify(obj));
}

// export function getSelfToken(){
//     var obj;
//     var key=user.selfToken;
//     obj=(localStorage.getItem(user.user));
//     if(obj!=null){
//         obj=JSON.parse(obj);
//         return obj[key];
//     }else{
//         return obj;
//     }
// }

export  function getSsoToken(){
    var obj;
    var key=user.ssoToken;
    obj=(readCookie(user.user));
    obj=JSON.parse(obj);
    return obj[key];
}

export function setSsoToken(token){
    var obj=(readCookie(user.user));
    obj=JSON.parse(obj);
    var key=user.ssoToken;
    obj[key]=token;
    writeCookie(user.user, JSON.stringify(obj));
}

export function getAppToken(){
    var obj;
    var key=user.appToken;
    obj=(readCookie(user.user));
    obj=JSON.parse(obj);
    return obj[key];
}

export function setAppToken(token){
    var obj=readCookie(user.user);
    if(obj){
        obj=JSON.parse(obj);
    }else{
        obj={};
    }
    var key=user.appToken;
    obj[key]=token;
    writeCookie(user.user, JSON.stringify(obj));

}
export function setUserAuthType(token){
    var obj=readCookie(user.user);
    if(obj){
        
        obj=JSON.parse(obj);
    }else{
        obj={};
    }
    var key=user.authType;
    obj[key]=token;
    writeCookie(user.user, JSON.stringify(obj));
}

export function getUserAuthType(){
    var obj;
    var key=user.authType;
    obj=(readCookie(user.user));
    obj=JSON.parse(obj);
    if(obj)
        return obj[key];
    else
        return false;
}

export function isSsoLogin(){
    if(getSelfToken() && getSsoToken() && getAppToken)
        return true;
    else
        return false;    
}

export function isSelfLogin(){
    if(getSelfToken() )
        return true;
    else
        return false;    
}

export function isLogin(){
    switch(getUserAuthType()){
        
        case authentication.ssoAuthType:
            //ug("getUserAuthType: authentication",authentication )
            return isSsoLogin();
        case authentication.selfAuthType:
            return isSelfLogin();
        default:
            return false;
    }
}

export function removeUserToken(){
    deleteCookie(user.user);
    //added 01122022 to remove the stored userId as well
    deleteCookie("creator_userId"); 
    clearPagePreviews();
}
// //ug("removeUserToken",removeUserToken())
// export function checkCallback(token,appToken,authType,callback){
//     if(token && appToken && authType){
//         setUserAuthType(authType)
//         setSelfToken(token) 
//         setAppToken(appToken) 
//         window.location.assign(callback)
//         return true;
//     }else{
//         isLogin()
//     }

// }
